



















































































































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import CashbackDetailInfo from "@/views/app/CashbackDetailInfo.vue";
import BlurredTenant from '@/components/BlurredTenant.vue';
import { encode } from "@common/util/base64Util";

export default Vue.extend({
  components: {CashbackDetailInfo, BlurredTenant},
  data() {
    const that = this;
    const dataId = that.$route.params.id
    return {
      showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
      listSubmit: [],
      infoPayment: {},
      description: "",
      sumTotal: 0,
      showDialog: false,
      dialog: {
        isActive: false,
        isLogout: true,
        title: 'Pay Cashback',
      },
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "date",
          "sort-desc": true,
          "show-expand": true,
        },
        content: {
          name: userManager.checkRole([
            "systemAdmin",
            "admin",
          ]) ? "Cashback" : " Revenue",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              status: {
                type: "select",
                attrs: {
                  label: "Status",
                  items: [
                    { text: "Paid", value: 1 },
                    { text: "Unpaid", value: 0 },
                  ],
                },
                rules: {
                  equal_to: {},
                },
              },
              point: {
                type: "number",
                attrs: {
                  label: "Total",
                },
                rules: {
                  greater_than: {
                    attrs: {
                      label: "Total (min)",
                      xOptions: {
                        content: {
                          resultFilter: () => 0,
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          displayFields: {
             date: {
               text: "Date",
                               options: {
                  transform: (value) => {
                    if (value == null) return '';
                    try {
                      const date = new Date(value);
                      if (isNaN(date.getTime())) return '';
                      const year = date.getFullYear();
                      const month = String(date.getMonth() + 1).padStart(2, '0');
                      const day = String(date.getDate()).padStart(2, '0');
                      return `${year}-${month}-${day}`;
                    } catch (error) {
                      console.error('Date transform error:', error);
                      return '';
                    }
                  },
                   to: (value, row) => {
                      if (value == null || row == null) return '#';
                      
                      console.log('value', value);
                      
                      try {
                        const clickedDate = new Date(value);
                        if (isNaN(clickedDate.getTime())) return '#';
                        const gmtStartDate = Date.UTC(clickedDate.getUTCFullYear(), clickedDate.getUTCMonth(), clickedDate.getUTCDate(), 0, 0, 0, 0);
                      
                      // Calculate stopTime values
                      const stopTimeFrom = gmtStartDate - 7* 3600* 1000;
                      const stopTimeTo = gmtStartDate + (24 * 60 * 60 * 1000) - 7* 3600* 1000;
                      const tenantId = row.tenant?._id || row.tenantId;

                      const filtersChargingSessions = {
                       "customPerPage": 0,
                       "dataOptions": {
                         "groupBy": [],
                         "groupDesc": [],
                         "itemsPerPage": 50,
                         "multiSort": false,
                         "mustSort": false,
                         "page": 1,
                         "sortBy": [
                           "startTime"
                         ],
                         "sortDesc": [
                           false
                         ]
                       },
                       "filters": []
                     };

                     // Build URL with all filters as parameters instead of in table_options
                     const ocpiModeMeta = that.$route?.meta?.ocpiMode;
                     let urlParams = `table_options=${encode(JSON.stringify(filtersChargingSessions))}`;
                     
                     // Add all filter parameters to URL
                     urlParams += `&tenantId=${tenantId}`;
                     urlParams += `&stopTimeFrom=${stopTimeFrom}`;
                     urlParams += `&stopTimeTo=${stopTimeTo}`;
                     
                     // Add OCPI mode to URL parameters
                     if (ocpiModeMeta === "roaming_in") {
                       urlParams += `&ocpi=true&ocpiData=null`;
                     } else if (ocpiModeMeta === "roaming_out") {
                       urlParams += `&ocpi=true&ocpiData=not_null`;
                     } else {
                       // Local cashback mode
                       urlParams += `&ocpi=false`;
                     }
                     
                    return `/app/Sessions?${urlParams}`;
                      } catch (error) {
                        console.error('Error in to function:', error);
                        return '#';
                      }
                  },
               },
             },
             powerConsumption: {
               text: "Power Consumption (kWh)",
               sortable: true,
             },
             electricityTariff: {
               text: "Electricity Tariff",
               sortable: true,
             },
             powerCost: {
               text: "Power Cost (VND)",
               sortable: true,
             },
             point: {
               text: "Revenue (VND)",
               sortable: true,
             },
             netRevenue: {
               text: "Net Revenue (VND)",
               sortable: true,
             },
             ratio: {
               text: "Ratio",
               sortable: true,
             },
             partnerRevenue: {
               text: "Partner Revenue (VND)",
               sortable: true,
             },
             status: {
               text: "Status",
             },
             describe: userManager.checkRole(["systemAdmin", "admin"]) && {
               text: "Description",
             },
                           // Add organization field for roaming_out mode
              organization: userManager.checkRole(["systemAdmin", "admin", "cpoGroup"]) && {
                text: "Organization",
                options: {
                  subProp: "tenant.name",
                  transform: (value, row) => {
                    if (row == null) return "N/A";
                    try {
                      // For roaming_out mode, show ocpiData.session.party_id if no tenant
                      if (that.$route?.meta?.ocpiMode === "roaming_out" && !row.tenant && row.ocpiData?.session?.party_id) {
                        return row.ocpiData.session.party_id;
                      }
                      // Default to tenant.name
                      return value || "N/A";
                    } catch (error) {
                      console.error('Organization transform error:', error);
                      return "N/A";
                    }
                  },
                },
              },
           },
          multiSelectActionButtons: {
            export: userManager.checkRole([
              "systemAdmin",
              "admin",
            ]) && {
              content: {
                text: "Pay",
                icon: "mdi-recurring-payment",
              },
              on: {
                xClick({ self }) {
                  const dataTable = self.context();
                  const listSubmit = dataTable.model.value.filter((item) => item.status !== 1).map((item) => ({ ...item }));
                  let sum = 0;
                  dataTable.model.value.forEach((item) => {
                    if (item.status === 0) {
                      sum += item.point;
                    } else if (item.status === 2) {
                      sum += (item.point - item.partialPayment);
                    }
                  });
                  for (let i = 0; i < listSubmit.length; i++) {
                    if (listSubmit[i].status === 2) {
                      listSubmit[i].point = (listSubmit[i].point - listSubmit[i].partialPayment)
                    }
                  }
                  that.description = ""
                  that.listSubmit = listSubmit;
                  that.sumTotal = sum;
                  that.dialog.isActive = true;
                },
              },
            },
          },
          topActionButtons: {

          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["systemAdmin", "admin"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "name",
                    },
                  },
                },
                ext: {
                  condition: (_, item) => {
                    return item.status !== 1;
                  }
                }
              },
              info: {
                content: {
                  icon: "mdi-information-outline",
                },
                on: {
                  async xClick() {
                    const filters = [
                      {
                        key: "tenantId",
                        operator: "equal_to",
                        value: dataId,
                      },
                      {
                        key: "default",
                        operator: "equal_to",
                        value: true,
                      },
                    ];
                    const { items } = await coreApiClient.call(
                      "userPayments",
                      "findAll",
                      {
                        payload: JSON.stringify({
                          orderBy: "name",
                          orderType: "asc",
                          filters,
                        }),
                      }
                    );
                    if (items.length !== 0) {
                      alert(
                        "Bank Card Number: " + items[0].bankCardNumber + "\n" +
                        "Card Holder Name: " + items[0].cardHolderName + "\n" +
                        "Bank Name: " + items[0].bankName + "\n" +
                        "Bank Branch: " + items[0].bankBranch + "\n"
                      );
                    }
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Information",
                    },
                  },
                },
              },
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const id = that.$route.params.id;
              return await that.getAll(id, options);
            },
          },
          default: {
            defaultInputs: {
              status: {
                type: "boolean",
                attrs: {
                  label: "Paid",
                },
                ext: {
                  defaultValue: true,
                },
              },
            },
            editForm: userManager.checkRole(["systemAdmin", "admin"]) && {
              content: {
                fieldNames: ["describe"],
              },
            },
          },
        },
      },
    };
  },
  methods: {
    async getAll(id, options) {
      const payload = JSON.parse(options.payload || "{}")
      if (!payload.filters) {
        payload.filters = [];
      }
      
      if (userManager.checkRole(["retailer"], true)) {
          payload.filters.push({
              key: "retailerUserId",
              operator: "equal_to",
              value: userManager.getUserInfo()._id,
          });
      } else {
        payload.filters = [
          ...payload.filters,
          {
            key: "tenantId",
            operator: "equal_to",
            value: id,
          },
        ];
      }
      options.payload = JSON.stringify(payload);
             // For local cashback (default route), use 'local' as ocpiMode
       // For roaming routes, use the meta ocpiMode
       let ocpiModeMeta = this.$route?.meta?.ocpiMode as string | undefined;
       if (!ocpiModeMeta) {
         ocpiModeMeta = 'local'; // Default to 'local' for the main cashback route
       }
       console.log('CashbackDetail getAll - ocpiMode:', ocpiModeMeta, 'route:', this.$route?.path);
       
       const apiOptions = { ...(options || {}) };
       // Always add ocpiMode parameter
       apiOptions.ocpiMode = ocpiModeMeta;
       console.log('CashbackDetail getAll - apiOptions with ocpiMode:', apiOptions);
      
      const { items, count } = await coreApiClient.call("cashBacks", "findAll", apiOptions);
      return [items, count];
    },
    async submitPay() {
      const { listSubmit, description } = this;
      
      // Get ocpiMode from route meta, default to 'local' if not present
      let ocpiModeMeta = this.$route?.meta?.ocpiMode as string | undefined;
      if (!ocpiModeMeta) {
        ocpiModeMeta = 'local'; // Default to 'local' for the main cashback route
      }
      
      await coreApiClient.call(
        "cashBacks",
        "updateMany",
        {
          ocpiMode: ocpiModeMeta,
        },
        {
          data: [...listSubmit.map((item) => ({ ...item, status: 1, describe: description }))],
        }
      );
      this.dialog.isActive = false;
      // reload page
      this.$router.go();
    },
    async initialize() {
      const id = this.$route.params.id;
      const filters = [
        {
          key: "tenantId",
          operator: "equal_to",
          value: id,
        },
        {
          key: "default",
          operator: "equal_to",
          value: true,
        },
      ];
      const { items } = await coreApiClient.call(
        "userPayments",
        "findAll",
        {
          payload: JSON.stringify({
            orderBy: "name",
            orderType: "asc",
            filters,
          }),
        }
      );
      if (items.length !== 0) {
        this.infoPayment = items[0];
      }
    },
  },
  created() {
    if (userManager.checkRole(["systemAdmin", "admin"])) {
      this.initialize();
    }
  },
});

